module.exports = __webpack_public_path__ + "img/placeholder_mobile.dd371a3e.svg";